var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMercedesBenz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 192.756 192.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h192.756v192.756H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.378 184.252c-48.531 0-87.874-39.344-87.874-87.874 0-48.531 39.343-87.874 87.874-87.874 48.532 0 87.874 39.343 87.874 87.874 0 48.53-39.342 87.874-87.874 87.874z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.402 109.652l-71.344 29.529c15.032 25.258 42.272 40.67 71.648 40.518 29.301-.076 56.465-15.643 71.344-40.975l-71.648-29.072zM84.044 88.797l11.369-75.311c-29.301.381-56.312 16.176-70.962 41.585-14.726 25.409-14.879 56.693-.457 82.255l60.05-48.529zM108.381 89.796l60.736 47.002c14.117-25.561 13.811-56.617-.914-81.873a83.143 83.143 0 0 0-70.658-41.433l10.836 76.304z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercedesBenz);
export default __webpack_public_path__ + "static/media/mercedes-benz.07e2d14e.svg";
export { ForwardRef as ReactComponent };